import { ReactComponent as CheckIcon } from "../../../icons/check.svg";
import { ReactComponent as ArrowRightIcon } from "../../../icons/arrowRight.svg";
import { Button, ButtonSizes } from "../../core/Button/Button";
import { CollaboratorCalibration } from "../../../types/api/potentialMatrix.type";
import {
  StyledCalibrationTransition,
  StyledCmCollaborator,
  StyledCollaboratorDetails,
  StyledCollaboratorInformations,
  StyledCollaboratorToView,
} from "./HeaderCollaboratorCalibration.styled";
import { Avatar, AvatarDimensionsEnum } from "../../core/Avatar/Avatar";
import { getInitials } from "../../../utils/collaborators.utils";
import { FontWeightEnum, IconSizeEnum } from "../../../types/AppTypes";
import { BodyTyp } from "../../Typography/Typography";
import { IconManager } from "../../core/IconManager/IconManager";
import { theme } from "../../../constants/StyledComponents";
import {
  PERFORMANCE_COACH_LABEL,
  CONFIRM_LABEL,
  EMPTY_STRING,
} from "../../../constants/Dictionary";
import { Tooltip } from "../../core/Tooltip/Tooltip";
import { PendingCalibration } from "../CalibrationModal";

interface HeaderCollaboratorCalibrationProps {
  selectedCollaborator: CollaboratorCalibration | null;
  openModalCollaboratorExaminated: boolean;
  isCollaboratorExaminated: boolean;
  onConfirmCalibration: () => void;
  pendingCalibration: PendingCalibration | null;
}

export const HeaderCollaboratorCalibration = ({
  selectedCollaborator,
  openModalCollaboratorExaminated,
  isCollaboratorExaminated,
  onConfirmCalibration,
  pendingCalibration,
}: HeaderCollaboratorCalibrationProps) => {
  return (
    <>
      {openModalCollaboratorExaminated ||
        (selectedCollaborator && (
          <StyledCollaboratorToView>
            {isCollaboratorExaminated && (
              <Tooltip message={PERFORMANCE_COACH_LABEL} width={116}>
                <StyledCmCollaborator>
                  <Avatar
                    variant={AvatarDimensionsEnum.X_SMALL}
                    initials={
                      selectedCollaborator.cm
                        ? getInitials(
                            selectedCollaborator.cm.name,
                            selectedCollaborator.cm.surname,
                          )
                        : EMPTY_STRING
                    }
                    collaboratorId={selectedCollaborator.cm?.id ?? 0}
                  />
                  <BodyTyp variant="3" fontWeight={FontWeightEnum.MEDIUM}>
                    {selectedCollaborator.cm
                      ? `${selectedCollaborator.cm.surname} ${selectedCollaborator.cm.name}`
                      : EMPTY_STRING}
                  </BodyTyp>
                </StyledCmCollaborator>
              </Tooltip>
            )}
            <StyledCollaboratorDetails>
              <Avatar
                collaboratorId={selectedCollaborator.collaborator.id}
                initials={getInitials(
                  selectedCollaborator.collaborator.name,
                  selectedCollaborator.collaborator.surname,
                )}
                variant={AvatarDimensionsEnum.SMALL}
              />
              <StyledCollaboratorInformations>
                <BodyTyp
                  variant="2"
                  fontWeight={FontWeightEnum.MEDIUM}
                  noLineHeight
                >
                  {selectedCollaborator.collaborator.surname}{" "}
                  {selectedCollaborator.collaborator.name}
                </BodyTyp>
                <StyledCalibrationTransition>
                  <BodyTyp
                    variant="3"
                    fontWeight={FontWeightEnum.SEMIBOLD}
                    color={theme.colors.grey_2}
                    noLineHeight
                  >
                    {`${selectedCollaborator.calibration.proposedScreen} - ${selectedCollaborator.calibration.proposedDimensionPercentage}`}
                  </BodyTyp>
                  <IconManager
                    size={IconSizeEnum.XSMALL}
                    color={theme.colors.grey_2}
                  >
                    <ArrowRightIcon />
                  </IconManager>
                  <BodyTyp
                    variant="3"
                    fontWeight={FontWeightEnum.SEMIBOLD}
                    color={theme.colors.grey_2}
                    noLineHeight
                  >
                    {`${pendingCalibration?.finalScreen ?? selectedCollaborator.calibration.finalScreen} - ${pendingCalibration?.finalDimensionPercentage ?? selectedCollaborator.calibration.finalDimensionPercentage}`}
                  </BodyTyp>
                </StyledCalibrationTransition>
              </StyledCollaboratorInformations>
            </StyledCollaboratorDetails>
            <Button
              icon={<CheckIcon />}
              label={CONFIRM_LABEL}
              onClick={onConfirmCalibration}
              size={ButtonSizes.SMALL}
              sizeIcon={IconSizeEnum.SMALL}
            />
          </StyledCollaboratorToView>
        ))}
    </>
  );
};
